import { Icon, IconSetArgs } from '../iconsSet.class';



export const controlsIcons: IconSetArgs<Icon> = {
   id: 'CRL',
   getSvg: ic => ic.svg,
   getTitle: ic => ic.title || '',
   objects: [
      {
         id: 'DELETE',
         svg: `<svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12"> <path fill="#FFF" fill-rule="nonzero" d="M6.707 1.707A1<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16"> <g fill="none" fill-rule="evenodd"> <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/> <g stroke="#FFF"> <path d="M5 5l6 6M11 5l-6 6"/> </g> </g> </svg> 1 0 0 0 5.293.293l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 1 0 1.414-1.414L2.414 6l4.293-4.293z"/> </svg> `,
      },
      {
         id: 'SORTER',
         svg: `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 10 16" > <g fill="none" fill-rule="evenodd" stroke-width="2"> <path d="M1 6l4-4 4 4" stroke-width="2" class="up"/> <path d="M1 10l4 4 4-4" stroke-width="2" class="down"/> </g> </svg>`,
      },
      {
         id: 'FILTER',
         svg: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16"> <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h12v3.476L9 8.048v3.973L5 15V8.048L1 4.476V1z"/> </svg>`,
      },
   ]
};